import { mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as Api from '../../../../store/bulk/update/bulk.update.api';

import { ShipmentConfigurationService } from '../../../../services/shipping-configuration-service';
import { AsyncJobHelper } from '../../../../services/async-job-helper';
import { EXTERNAL_SHIP_FROM_PREFIX } from '../../../../store/csw/csw.fulfillment-plan-to-csw';

const makeApiCallWithIds = (job) => {
  const { bulkUpdateTypeData, model, ids } = job;

  const requestModel = ShipmentConfigurationService.mapModelToRequest(model);
  const request = {
    ...requestModel,
    filters: bulkUpdateTypeData.requestFilter(ids),
  };
  return Api.bulkShippingUpdate(request).pipe(
    mergeMap((data) => {
      const foldedData = AsyncJobHelper.foldMultiJobResponse(data);
      return of(foldedData);
    }),
  );
};

const makeExternalFulfillmentApiCallWithJobGuid = (job) => {
  const {
    model,
    jobData: { bulkUpdateJobGuid },
  } = job;

  const { externalFulfillmentConfiguration } = model;

  const requestModel = {
    ...externalFulfillmentConfiguration,
    sellerFulfillmentProviderId: externalFulfillmentConfiguration.sellerFulfillmentProviderId?.replace(EXTERNAL_SHIP_FROM_PREFIX, ''),
  };

  const request = {
    bulkUpdateJobGuid,
    externalFulfillmentConfiguration: requestModel,
  };
  return Api.bulkUpdateExternalFulfillment(request).pipe(
    mergeMap((data) => {
      return of({ jobGuids: data.jobGuids });
    }),
  );
};

const makeApiCallWithJobGuid = (job) => {
  const {
    model,
    jobData: { bulkUpdateJobGuid },
  } = job;

  const requestModel = ShipmentConfigurationService.mapModelToRequest(model);
  const request = {
    bulkUpdateJobGuid,
    shippingConfiguration: requestModel,
  };
  return Api.bulkUpdateShipping(request).pipe(
    mergeMap((data) => {
      return of({ jobGuids: data.jobGuids });
    }),
  );
};

export const shippingConfiguration = {
  id: 'shipping-configuration',
  applicableBulkActions: [],

  handler: (job) => {
    const {
      model,
      jobData: { bulkUpdateJobGuid },
    } = job;

    if (model?.externalFulfillmentConfiguration) {
      return makeExternalFulfillmentApiCallWithJobGuid(job);
    }

    const makeApiCall$ = bulkUpdateJobGuid ? makeApiCallWithJobGuid : makeApiCallWithIds;

    return makeApiCall$(job);
  },
};
